import React from 'react';
export function Footer() {
  return <footer className="py-12 px-4 border-t border-pink-200 bg-brand-dark text-center" data-id="element-129">
      <div className="max-w-4xl mx-auto" data-id="element-130">
        <div className="flex items-center justify-center gap-2 mb-6" data-id="element-131">
          <span className="text-2xl" data-id="element-132">💎</span>
          <span className="font-display font-bold tracking-wider text-gray-900 uppercase text-lg" data-id="element-133">
            CM Digital Pro
          </span>
        </div>

        <p className="text-gray-500 mb-2" data-id="element-134">
          El sistema que transforma la forma en que las mamás entrenan en
          Argentina.
        </p>
        <p className="text-gray-600 font-medium italic" data-id="element-135">
          Porque sentirte bien… 👉 no debería ser tan difícil.
        </p>

        <div className="mt-12 text-xs text-gray-400" data-id="element-136">
          <p data-id="element-137">
            © {new Date().getFullYear()} CM Digital Pro. Todos los derechos
            reservados.
          </p>
          <p className="mt-2" data-id="element-138">
            Este sitio no es parte del sitio web de Facebook ni de Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </div>
    </footer>;
}